import Vue from 'vue'

export function generateSetChild(prop) {
	return (state, { item }) => Vue.set(state, prop, item)
}

export function generateAddArrayChild(prop) {
	return (state, { item }) => state[prop].push(item)
}

export function generateUpdateArrayChild(prop, identify = "id") {
	return (state, { item }) => {
		var idx = state[prop].findIndex(v => v[identify] == item[identify])
		Vue.set(state[prop], idx, item)
	}
}

export function generateRemoveArrayChild(prop, identify = "id") {
	return (state, { item }) => {
		var idx = state[prop].findIndex(v => v[identify] == item[identify])
		if (idx >= 0) {
			state[prop].splice(idx, 1)
		}
	}
}

export function generateSetMapChild(prop, objectKey) {
	return (state, { item, key = null }) => {
		if (item) {
			Vue.set(state[prop], key || item[objectKey], item)
		} else {
			Vue.delete(state[prop], key)
		}
	}
}